import cx from 'classnames';
import { getLabel } from 'mk/bazaar/product/categories';
import { ListItem } from 'mk2/components/ListItem';
import { ListItemIcon } from 'mk2/components/ListItemIcon';
import { PhotoEntity } from 'mk2/schemas';
import React from 'react';
import styles from './ProductFormAdding.mscss';

interface OwnProps {
    className?: string;
    title?: string;
    category?: string;
    mainPhoto?: PhotoEntity;
}

type Props = OwnProps;

const ProductFormAdding: React.FunctionComponent<Props> = ({ className, title, category, mainPhoto }) => {
    if (!title && !category && !mainPhoto) {
        return null;
    }

    return (
        <div className={cx(styles.ProductFormAdding, className)}>
            <ListItem icon={<ListItemIcon photo={mainPhoto} photoVersion="s170x170" />} isLast>
                {title && <div className={styles.ProductFormAdding__title}>{title}</div>}
                {category && <div className={styles.ProductFormAdding__category}>{getLabel(category)}</div>}
            </ListItem>
        </div>
    );
};

ProductFormAdding.displayName = 'ProductFormAdding';

export default React.memo<Props>(ProductFormAdding);
